import { render, staticRenderFns } from "./MintalMesPrdCraftConfigEdit.vue?vue&type=template&id=4c5b7da8&"
import script from "./MintalMesPrdCraftConfigEdit.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdCraftConfigEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports